import { render, staticRenderFns } from "./lowest-selling.vue?vue&type=template&id=0d075106"
import script from "./lowest-selling.vue?vue&type=script&lang=js"
export * from "./lowest-selling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports